import { FormattedMessage } from 'react-intl';
import { LOCATION_BARCODE } from '../../../enums/document-type';
import { messages } from '../messages';

export const locationBarcodes = {
  id: LOCATION_BARCODE,

  getDocumentRequestNotificationProps: () => ({
    title: <FormattedMessage {...messages.printingLocationBarcodesTitle} />,
  }),
};
